const workAnalyzer = {
  hu: {
    // Fejléc
    workDetails: "Munka részletei",

    // Fájlok panel
    files: "Fájlok",
    uploadFiles: "Fájl import",
    uploading: "Feltöltés...",
    filesUploaded: "Fájl(ok) sikeresen feltöltve.",
    uploadError: "Feltöltési hiba történt.",
    downloadError: "Letöltési hiba.",
    deleteError: "Törlési hiba.",
    confirmDeleteFile: "Biztos törölni akarod a fájlt?",
    fileDeleted: "Fájl törölve.",
    fileMenuPreview: "Előnézet",
    fileMenuDownload: "Letöltés",
    fileMenuImport: "Import",
    fileMenuManualImport: "Kézi import",
    fileMenuDelete: "Törlés",

    // Import overlay
    importInProgress: "Import folyamatban...",

    // AI Preview modal
    aiPreviewTitle: "AI Import Preview",
    aiPreviewAddRow: "Új elem hozzáadása",
    aiPreviewCancel: "Mégsem",
    aiPreviewImport: "Import",

    // Dropdown placeholders
    searchPlaceholder: "Keresés... (* = bármi)",
    noColor: "– Nincs szín",
    noMilling: "– Nincs marás",
    noMillingAvailable: "Nincs elérhető marás",

    // Update Work modal
    updateWork: "Munka frissítése",
    companyPriceHint: "Lapszabászat ár:",
    carpenterPaidHint: "Asztalos fizetett:",
    companyLaborHint: "Lapszabászat munkadíj:",
    companyMaterialHint: "Lapszabászat anyagár:",

    // Status fields
    orderStatus: "Rendelés állapota",
    orderNotPlaced: "Rendelés nincs leadva",
    orderTotal: "Rendelés összege",
    clientPaid: "Kliens fizetett",
    userPaid: "Felhasználó fizetett",
    clientRemaining: "Kliens hátralévő összege",
    userRemaining: "Asztalos hátralévő összege",
    woodPrice: "Anyagár",
    companyWoodPrice: "Lapszabászat anyagár",
    laborUser: "Asztalos munkadíj",
    laborCompany: "Lapszabászat munkadíj",
    measureDate: "Felmérés dátuma",
    cancelDate: "Törlés dátuma",
    orderDate: "Megrendelés dátuma",
    finishDate: "Befejezés dátuma",
    showMore: "Több mutatása",
    showLess: "Kevesebb mutatása",

    // Anyag panel
    materials: "Alapanyag",
    totalWoodPrice: "Teljes alapanyagár",
    unitPrice: "Darab ár",

    // Export / Import
    exportExcel: "Export (Excel)",
    exportInProgress: "Exportálás...",
    exportSuccess: "Export kész: {{file}}",
    exportError: "Export közben hiba történt.",
    exportNoPermission: "Nincs jogosultság az exporthoz.",
    noExportItems: "Nincs exportálható tétel",
    import: "Import",
    importError: "Hiba történt importálás közben.",
    importNoItems: "Nincs importálható tétel.",
    importSuccess: "{{count}} tétel sikeresen importálva",
    importHint: "CMR, CSV vagy XLSX import",
    mdfNoItems: "Nincs MDF tétel ehhez a munkához.",
    mdfExportError: "MDF export hiba.",
    itemsImported: "tétel sikeresen importálva",
    itemsImportedAi: "tétel importálva",
    imageParseError: "Nem sikerült adatot kiolvasni a képből.",
    imageOpenError: "Nem sikerült megnyitni a képet.",

    // Order
    confirmOrderTitle: "Rendelés megerősítése",
    confirmOrderBody: "Biztosan szeretnéd leadni ezt a rendelést?",
    confirm: "Megerősítés",
    order: "Rendelés",
    orderNoTables: "Nincsenek elkészített táblák.",
    orderNoItems: "Nincsenek elkészített elemek.",
    orderUnassignedItems: "Még {{count}} tétel nincs táblához rendelve.",
    orderError: "Rendelési hiba.",

    // Buttons
    update: "Frissítés",
    tables: "Táblák",
    now: "most",
    fileTableName: "Név",
    fileTableSize: "Méret",
    fileTableExt: "Kiterjesztés",
    fileTableDate: "Dátum"
  },
  ro: {
    workDetails: "Detalii lucrare",
    files: "Fișiere",
    uploadFiles: "Import fișier",
    uploading: "Se încarcă...",
    filesUploaded: "Fișier(e) încărcate cu succes.",
    uploadError: "Eroare la încărcare.",
    downloadError: "Eroare la descărcare.",
    deleteError: "Eroare la ștergere.",
    confirmDeleteFile: "Sigur dorești să ștergi fișierul?",
    fileDeleted: "Fișier șters.",
    fileMenuPreview: "Previzualizare",
    fileMenuDownload: "Descărcare",
    fileMenuImport: "Import",
    fileMenuManualImport: "Import manual",
    fileMenuDelete: "Ștergere",
    importInProgress: "Import în curs...",
    aiPreviewTitle: "Previzualizare Import AI",
    aiPreviewAddRow: "Adăugare element nou",
    aiPreviewCancel: "Anulează",
    aiPreviewImport: "Import",
    searchPlaceholder: "Căutare... (* = orice)",
    noColor: "– Fără culoare",
    noMilling: "– Fără frezare",
    noMillingAvailable: "Nu există frezare disponibilă",
    updateWork: "Actualizare lucrare",
    companyPriceHint: "Preț debitare:",
    carpenterPaidHint: "Tâmplar a plătit:",
    companyLaborHint: "Manoperă debitare:",
    companyMaterialHint: "Material debitare:",
    orderStatus: "Stare comandă",
    orderNotPlaced: "Comanda nu a fost plasată",
    orderTotal: "Total comandă",
    clientPaid: "Client a plătit",
    userPaid: "Utilizator a plătit",
    clientRemaining: "Client mai are de plătit",
    userRemaining: "Utilizator mai are de plătit",
    woodPrice: "Preț material",
    companyWoodPrice: "Preț material debitare",
    laborUser: "Manoperă tâmplar",
    laborCompany: "Manoperă debitare",
    measureDate: "Data măsurătorii",
    cancelDate: "Data anulării",
    orderDate: "Data comenzii",
    finishDate: "Data finalizării",
    showMore: "Afișează mai mult",
    showLess: "Afișează mai puțin",
    materials: "Material",
    totalWoodPrice: "Preț total material",
    unitPrice: "Preț/unitate",
    exportExcel: "Export (Excel)",
    exportInProgress: "Se exportă...",
    exportSuccess: "Export realizat: {{file}}",
    exportError: "Eroare la export.",
    exportNoPermission: "Nu ai permisiunea de a exporta.",
    noExportItems: "Nu există piese de exportat",
    import: "Import",
    importError: "A apărut o eroare la import.",
    importNoItems: "Nu există piese de importat.",
    importSuccess: "{{count}} piese importate cu succes",
    importHint: "Import CMR, CSV sau XLSX",
    mdfNoItems: "Nu există piese MDF pentru această lucrare.",
    mdfExportError: "Eroare la export MDF.",
    itemsImported: "piese importate cu succes",
    itemsImportedAi: "piese importate",
    imageParseError: "Nu s-au putut citi datele din imagine.",
    imageOpenError: "Nu s-a putut deschide imaginea.",
    confirmOrderTitle: "Confirmare comandă",
    confirmOrderBody: "Ești sigur că vrei să trimiți această comandă?",
    confirm: "Confirmare",
    order: "Comandă",
    orderNoTables: "Nu există plăci create.",
    orderNoItems: "Nu există piese create.",
    orderUnassignedItems: "{{count}} piese nu sunt atribuite plăcilor.",
    orderError: "Eroare la comandă.",
    update: "Actualizare",
    tables: "Plăci",
    now: "acum",
    fileTableName: "Nume",
    fileTableSize: "Dimensiune",
    fileTableExt: "Extensie",
    fileTableDate: "Dată"
  },
  en: {
    workDetails: "Work details",
    files: "Files",
    uploadFiles: "File import",
    uploading: "Uploading...",
    filesUploaded: "File(s) uploaded successfully.",
    uploadError: "Upload error occurred.",
    downloadError: "Download error.",
    deleteError: "Delete error.",
    confirmDeleteFile: "Are you sure you want to delete this file?",
    fileDeleted: "File deleted.",
    fileMenuPreview: "Preview",
    fileMenuDownload: "Download",
    fileMenuImport: "Import",
    fileMenuManualImport: "Manual import",
    fileMenuDelete: "Delete",
    importInProgress: "Import in progress...",
    aiPreviewTitle: "AI Import Preview",
    aiPreviewAddRow: "Add new item",
    aiPreviewCancel: "Cancel",
    aiPreviewImport: "Import",
    searchPlaceholder: "Search... (* = any)",
    noColor: "– No color",
    noMilling: "– No milling",
    noMillingAvailable: "No milling available",
    updateWork: "Update work",
    companyPriceHint: "Cutting price:",
    carpenterPaidHint: "Carpenter paid:",
    companyLaborHint: "Cutting labor:",
    companyMaterialHint: "Cutting material:",
    orderStatus: "Order status",
    orderNotPlaced: "Order not placed",
    orderTotal: "Order total",
    clientPaid: "Client paid",
    userPaid: "User paid",
    clientRemaining: "Client remaining",
    userRemaining: "User remaining",
    woodPrice: "Material price",
    companyWoodPrice: "Company material price",
    laborUser: "Carpenter labor",
    laborCompany: "Company labor",
    measureDate: "Measurement date",
    cancelDate: "Cancellation date",
    orderDate: "Order date",
    finishDate: "Finish date",
    showMore: "Show more",
    showLess: "Show less",
    materials: "Materials",
    totalWoodPrice: "Total material price",
    unitPrice: "Unit price",
    exportExcel: "Export (Excel)",
    exportInProgress: "Exporting...",
    exportSuccess: "Export completed: {{file}}",
    exportError: "An error occurred during export.",
    exportNoPermission: "You do not have permission to export.",
    noExportItems: "No items to export",
    import: "Import",
    importError: "An error occurred during import.",
    importNoItems: "No items to import.",
    importSuccess: "{{count}} items imported successfully",
    importHint: "Import CMR, CSV or XLSX",
    mdfNoItems: "No MDF items for this work.",
    mdfExportError: "MDF export error.",
    itemsImported: "items imported successfully",
    itemsImportedAi: "items imported",
    imageParseError: "Could not read data from image.",
    imageOpenError: "Could not open image.",
    confirmOrderTitle: "Confirm order",
    confirmOrderBody: "Are you sure you want to place this order?",
    confirm: "Confirm",
    order: "Order",
    orderNoTables: "No created tables available.",
    orderNoItems: "No created items available.",
    orderUnassignedItems: "{{count}} items are not assigned to tables.",
    orderError: "Order error.",
    update: "Update",
    tables: "Tables",
    now: "now",
    fileTableName: "Name",
    fileTableSize: "Size",
    fileTableExt: "Extension",
    fileTableDate: "Date"
  }
};

export default workAnalyzer;
